// Autogenerated by sprite compiler (large sprites)

export interface ILargeSprite {
  k: string
  d: string
  f: string
}

export const largeSprites = {
  chessBoard: { k: 'chessBoard', d:'goat/chess', f:'chess-board' },
  untilYourKingIsDeadLogo2: { k: 'untilYourKingIsDeadLogo2', d:'goat/chess', f:'until-your-king-is-dead-logo-2' },
}

